// Vendor Libs
import React from 'react';
import presets from '../components/layout/nav/layout-presets';

export const LayoutContext = React.createContext(presets.createDefaultLayout());
